var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-3" },
        [
          _c(
            "b-button",
            {
              staticClass: "ms-auto",
              attrs: {
                size: "lg",
                variant: "primary",
                to: { name: "accounting-budget-add" },
              },
            },
            [_vm._v(" Add Budget ")]
          ),
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-table", {
            attrs: {
              items: _vm.budgetEntries,
              fields: _vm.fields,
              responsive: "",
              bordered: "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              to: {
                                name: "budget-edit",
                                params: { id: row.item.id },
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "EditIcon" },
                            }),
                            _c("span", [_vm._v("Edit")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            attrs: {
                              to: {
                                name: "budget-report",
                                params: { id: row.item.id },
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "BarChartIcon" },
                            }),
                            _c("span", [_vm._v("Variance Report")]),
                          ],
                          1
                        ),
                        _c(
                          "b-dropdown-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.confirmDelete(row.item)
                              },
                            },
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "TrashIcon" },
                            }),
                            _c("span", [_vm._v("Delete")]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }